export default __webpack_public_path__ + "static/media/releasesPic.493b1ad2.png";